/**
 * Brand palette for JS inline styles.
 *
 * `src/assets/styles/colors.scss` already holds these for stylesheets, but SCSS
 * variables cannot be read from a `style={{...}}` object, so the same hexes were
 * being retyped across ~44 files. Import from here instead of hardcoding, and keep
 * the two files in step when a value changes.
 */
export const COLORS = {
  PRIMARY: "#f77e0b",
  WHITE: "#ffffff",
  WHITE_SMOKE: "#ffefef",
  GREY: "#333333",
  LIGHT_GREY: "#808080",
  DARK_GREY: "#3e3e3e",
  BLACK: "#000000",
  FOOTER_GREY: "#8b8b8b",

  BORDER: "#d9d9d9",
  DANGER: "#ff4d4f",

  RED: "rgba(255, 0, 0, 1)",
  GREEN: "rgba(140, 198, 63, 1)",
  ORANGE: "rgba(255, 165, 0, 1)",
};

export default COLORS;
